import api from './../../fetch/api.js'
import * as types from './../types.js'

const state = {
    newsListMsg: {
        data: [],
        msg: {}
    },
    allListMsg: {
        data: [],
        msg: {}
    }
}

const actions = {
    getNewsListApi({
        commit
    }) {
        api.newsListApi().then((res) => {
            commit(types.GET_NEWS_LIST, res);
        })
    },
    getAllListApi({
        commit
    }) {
        api.allListApi().then((res) => {
            commit(types.GET_ALL_LIST, res);
        })
    },
    cleanNewsListApi({
        commit
    }) {
        commit(types.CLEAN_NEWS_LIST);
    }
}

const getters = {
    newsListMsg: state => state.newsListMsg,
    allListMsg: state => state.allListMsg
}

const mutations = {
    [types.GET_NEWS_LIST](state, res) {
        state.newsListMsg = {
            ...state.newsListMsg,
            data: res.data.data
        };
    },
    [types.GET_ALL_LIST](state, res) {
        state.allListMsg = {
            ...state.allListMsg,
            data: res.data.data
        };
    },
    [types.CLEAN_NEWS_LIST](state) {
        state.newsListMsg = {
            ...state.newsListMsg,
            data: []
        };
    }
}

export default {
    state,
    actions,
    getters,
    mutations
}
